<script>
	module.exports = {
		props: {
			imageUrl: {
				required: true
			},
			productUrl: {
				type: String
			},
			onProductLinkClick: {
				type: Function,
				default: function () {}
			},
			altText: {
				type: String,
				default: ''
			},
			variant: {
				type: String
			}
		},
		data() {
			return {
				loaded: false
			};
		},
		methods: {
			onLoad() {
				this.loaded = true;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	.article-image {
		.article-featured-image-container {
			height: 3rem;
			width: 3rem;
			display: inline-block;

			> figure.article-featured-image {
				margin-bottom: 0rem;
				border-radius: 1.5rem;
				height: 100%;
				width: 100%;
			}

			img {
				height: 100%;
				width: 100%;
				object-fit: cover;
				object-position: center;
				opacity: 0; //hide alt text during load
				transition: opacity 0.1s;

				&.loaded {
					opacity: 1;
				}
			}
		}

		&.contain {
			img {
				object-fit: contain;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.article-image .article-featured-image-container {
			height: 7rem;
			width: 7rem;

			> figure.article-featured-image {
				border-radius: 4px;
			}
		}
	}
</style>
<template>
	<span
		class="article-image"
		:class="variant">
		<a
			v-if="productUrl && imageUrl"
			:href="productUrl"
			class="article-featured-image-container"
			@click="onProductLinkClick">
			<figure class="article-featured-image">
				<img
					:class="{ loaded }"
					:src="imageUrl"
					:alt="altText"
					@load="onLoad"
					@error="onLoad" />
			</figure>
		</a>
		<span
			v-if="!productUrl && imageUrl"
			class="article-featured-image-container">
			<figure class="article-featured-image">
				<img
					:class="{ loaded }"
					:src="imageUrl"
					:alt="altText"
					@load="onLoad"
					@error="onLoad" />
			</figure>
		</span>
	</span>
</template>
